import { Box, Card, Grid, IconButton, Typography } from '@mui/material';
import { Timeline } from '../../../../../components/History/TimeLine';
import BackdropComponent from '../../../../../components/Backdrop/BackdropComponent';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';
import { TimelineIcon } from '../../../../../components/History/TimeLineIcon';
import { useGetBatchEmployeeHistoryProvisionalQuery } from '../../../../../services/periodicosApi';

const CardRegistrationEvent = ({ historyItem }: { historyItem: any }) => (
    <Box flex={1} pl={2} pt={0.3} pb={3}>
        <Typography fontSize={'1.1rem'} fontWeight={700} mb={0}>
            Alta en Lote
        </Typography>
        <Grid container alignItems="center" mb={0.2}>
            <Grid item>
                <Typography color="#94A3B8" fontSize=".9rem">
                    31/1/2026 • 09:00 p. m. • Sistema
                </Typography>
            </Grid>
        </Grid>
        <Card
            sx={{
                backgroundColor: '#eff6ff',
                border: '1px solid #bfdbfe',
                p: 2,
                borderRadius: 2
            }}
        >
            <Typography fontSize="0.875rem" color="#64748B" fontWeight={500}>
                <span style={{ fontWeight: 600 }}>Lote:</span> LS-001
            </Typography>
            <Typography fontSize="0.875rem" color="#64748B" fontWeight={500} mt={1}>
                Tipo: semestral
            </Typography>
        </Card>
    </Box>
);
const CardUnknownEvent = () => (
    <Box flex={1} pl={2} pt={0.3} pb={3}>
        <Typography fontSize={'1.1rem'} fontWeight={700}>
            Unknown event
        </Typography>
    </Box>
);

const handleCardDisplay = (historyItem: any) => {
    // if (IS_BUSINESS_TYPE_CHANGE_EVENT(historyItem))
    //     return <CardBussinessTypeChangeEvent historyItem={historyItem} />;

    // if (IS_RENOVATION_EVENT(historyItem)) {
    //     return <CardRenovationEvent historyItem={historyItem} />;
    // }

    // if(IS_DEREGISTER_EVENT(historyItem)) {
    //     return <CardDeregisterEvent historyItem={historyItem} />;
    // }

    return <CardUnknownEvent />;
};

const getIconPropertiesByHistoryItem = (historyItem: any) => {
    // if (IS_BUSINESS_TYPE_CHANGE_EVENT(historyItem)) {
    //     return {
    //         borderColor: '#BBF7D0',
    //         backgroundColor: '#FFFFFF',
    //         icon: <ApartmentOutlinedIcon />
    //     };
    // }
    // if (IS_RENOVATION_EVENT(historyItem)) {
    //     return {
    //         borderColor: '#BFDBFE',
    //         backgroundColor: '#FFFFFF',
    //         icon: <CachedOutlinedIcon />
    //     };
    // }

    // if(IS_DEREGISTER_EVENT(historyItem)) {
    //     return {
    //         borderColor: '#ff6b6bff',
    //         backgroundColor: '#FFFFFF',
    //         icon: <StopCircleOutlinedIcon />
    //     };
    // }
    return {
        borderColor: '#E2E8F0',
        backgroundColor: '#FFFFFF',
        icon: <QuestionMarkOutlinedIcon />
    };
};

const BatchEventHistoryCard = ({ historyItem }: { historyItem: any }) => {
    return (
        <Box display="flex">
            <TimelineIcon {...getIconPropertiesByHistoryItem(historyItem)} />
            {handleCardDisplay(historyItem)}
        </Box>
    );
};

const HistoryDrawer = ({
    handleCloseDrawer,
    selectedEmployee,
    selectedBatchId
}: {
    handleCloseDrawer: () => void;
    selectedEmployee: any;
    selectedBatchId: number | null;
}) => {
    const selectedEmployeeId =
        Number(selectedEmployee?.idExamenEmpleado) ||
        Number(selectedEmployee?.examenEmpleado?.id) ||
        Number(selectedEmployee?.id) ||
        0;

    const { data: batchHistory, isFetching: isFetchingBatchHistory } =
        useGetBatchEmployeeHistoryProvisionalQuery(
            {
                batchId: Number(selectedBatchId),
                employeeId: selectedEmployeeId
            },
            {
                skip: !selectedBatchId || !selectedEmployeeId
            }
        );

    const historyItems =
        batchHistory?.historial ||
        batchHistory?.data?.historial ||
        batchHistory?.data ||
        [];

    const historyDataFound = Array.isArray(historyItems) && historyItems.length > 0;

    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                padding={1}
                sx={{ flexDirection: 'column', height: '100%' }}
            >
                <Grid>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            pl: 2,
                            pr: 0.5,
                            pt: 2,
                            pb: 2,
                            bgcolor: 'background.paper'
                        }}
                    >
                        <Box>
                            <Typography sx={{ fontWeight: 700, fontSize: '1.15rem', color: 'text.primary', lineHeight: 1.3 }}>
                                {`Historial: ${selectedEmployee?.nombre || '-'}`}
                            </Typography>
                            <Typography sx={{ fontSize: '0.8rem', color: '#94a3b8', fontWeight: 500, letterSpacing: 0.3 }}>
                                {`CUIL ${selectedEmployee?.cuil ?? '-'}`}
                            </Typography>
                        </Box>
                        <IconButton
                            onClick={handleCloseDrawer}
                            data-testid="drawer-icon-button-arrow-back"
                            sx={{ '&:hover': { bgcolor: 'grey.100' } }}
                        >
                            <CloseOutlinedIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
                        </IconButton>
                    </Box>
                    <Grid mt={2}>
                        {!historyDataFound && !isFetchingBatchHistory && (
                            <Box
                                width="100%"
                                height={`${`calc(100vh / 1.5)`}`}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Typography align="center" width="100%">
                                    No se encontraron datos de historial.
                                </Typography>
                            </Box>
                        )}
                        <Timeline>
                            {historyDataFound &&
                                historyItems.map((historyItem: any, index: number) => {
                                    return <BatchEventHistoryCard key={index} historyItem={historyItem} />;
                                })}
                        </Timeline>
                    </Grid>
                </Grid>
            </Box>
            <BackdropComponent loading={isFetchingBatchHistory} />
        </>
    );
};

export { HistoryDrawer };
